// removed by extract-text-webpack-plugin
module.exports = {"inlineLink":"User__inlineLink___2rexc","adminWarning":"User__adminWarning___3tbpF","adminChangeForm":"User__adminChangeForm___3gXzI"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/User/components/User.scss
// module id = 1226
// module chunks = 1